import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import Footer from '../components/Footer';

const Courses = () => {
  const [courses, setCourses] = useState([]);
  const [loading, setLoading] = useState(true);

  //Slow Loading Warning
  const [showSlowMessage, setShowSlowMessage] = useState(false);
  
  // State to track which course ID is currently expanded (for description)
  const [expandedCourseId, setExpandedCourseId] = useState(null);

  // 1. API URL Helper
  const BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';
  const API_URL = `${BASE_URL}/api`;

  useEffect(() => {

    //If takes > 3 sec, show warning
    const timer = setTimeout(() => {
      setShowSlowMessage(true);
    }, 3000);

    const fetchCourses = async () => {
      try {
        // 2. Use the variable
        const { data } = await axios.get(`${API_URL}/courses`);
        setCourses(data);
        setLoading(false);
        clearTimeout(timer);
      } catch (error) {
        console.error("Error fetching courses", error);
        setLoading(false);
        clearTimeout(timer);
      }
    };
    fetchCourses();
    return() => clearTimeout(timer);
  }, [API_URL]); // Add dependency

  // Helper function to toggle the view
  const toggleDescription = (id) => {
    if (expandedCourseId === id) {
      setExpandedCourseId(null); 
    } else {
      setExpandedCourseId(id); 
    }
  };

  return (
    <div className="d-flex flex-column min-vh-100 bg-light">
      
      {/* --- PAGE HEADER --- */}
      <div className="bg-success text-white text-center py-5" style={{ backgroundColor: '#004d40' }}>
        <h1 className="display-4 fw-bold">Our Courses</h1>
        <p className="lead">Explore our spiritual and educational programs designed for all levels.</p>
      </div>

      {/*-----LOADING SECTION-------*/}
      <div className="container my-5 flex-grow-1">
        {loading ? (
          <div className="text-center py-5">
            <div className="spinner-border text-success" role="status" style={{ width: '3rem', height: '3rem' }}></div>
            <h4 className="mt-4 text-muted">Loading courses...</h4>
            
            {/* This message only appears if loading takes longer than 3 seconds */}
            {showSlowMessage && (
              <div className="alert alert-light mt-4 d-inline-block shadow-sm border fade show" role="alert" style={{ maxWidth: '600px' }}>
                <h5 className="alert-heading text-dark fw-bold">
                  <i className="bi bi-info-circle me-2 text-success"></i>
                  Just a Moment...
                </h5>
                <hr />
                <p className="mb-0 text-secondary">
                  We are retrieving the latest course schedule from our secure database. This helps ensure you see the most up-to-date availability.
                  <br /><br />
                  <strong>Please feel free to explore the rest of the site</strong> while you wait. 
                  This page will update automatically as soon as the data is ready!
                </p>
              </div>
            )}
          </div>
        ) : (
          <div className="row g-4">
            {courses.map((course) => {
              const isExpanded = expandedCourseId === course._id;
              const isLongText = course.description && course.description.length > 100;

              return (
                <div key={course._id} className="col-md-6 col-lg-4">
                  <div className="card h-100 border-0 shadow-sm hover-effect">
                    <div className="card-header bg-white border-0 pt-4 pb-0 text-center">
                      <div className="mb-2">
                        {course.title.toLowerCase().includes('hifz') ? <i className="bi bi-book fs-1 text-success"></i> :
                         course.title.toLowerCase().includes('tajweed') ? <i className="bi bi-mic fs-1 text-success"></i> :
                         <i className="bi bi-mortarboard fs-1 text-success"></i>}
                      </div>
                      <h4 className="card-title fw-bold text-dark">{course.title}</h4>
                    </div>
                    <div className="card-body text-center d-flex flex-column">
                      <div className="mb-3">
                        <span className="badge bg-light text-dark border me-2">
                          <i className="bi bi-clock me-1"></i> {course.duration}
                        </span>
                        <span className="badge bg-warning text-dark">
                          {course.fee}
                        </span>
                      </div>
                      <div className="card-text text-muted small flex-grow-1 text-start px-2">
                        {isExpanded ? (
                          <span>{course.description} </span>
                        ) : (
                          <span>
                            {course.description ? course.description.substring(0, 100) : ''}
                            {isLongText && "..."}
                          </span>
                        )}
                        {isLongText && (
                          <span 
                            onClick={() => toggleDescription(course._id)}
                            className="text-success fw-bold ms-1" 
                            style={{ cursor: 'pointer', fontSize: '0.9em' }}
                          >
                            {isExpanded ? "(Show Less)" : "More"}
                          </span>
                        )}
                      </div>
                      
                      <Link 
                        to="/admissions" 
                        state={{ courseTitle: course.title }} 
                        className="btn btn-outline-success mt-4 w-100 rounded-pill fw-bold"
                      >
                        Apply Now
                      </Link>
                    </div>
                  </div>
                </div>
              );
            })}

            {courses.length === 0 && (
              <div className="text-center w-100 py-5">
                <h3 className="text-muted">No courses available at the moment.</h3>
              </div>
            )}
          </div>
        )}
      </div>
      <Footer />
    </div>
  );
};

export default Courses;